export enum AccountType {
  Mobile,
  Alipay,
  Wechat,
}
